const walletData = [
    {
      image: 'assets/images/nft/wallet/metamask.png',
      title: 'Metamask',
      content: 'MetaMask is a popular cryptocurrency wallet known for its ease of use, availability on both desktops.',
      btn_color: "btn-soft-primary"
    },
    {
      image: 'assets/images/nft/wallet/coinbase.png',
      title: 'Coinbase Wallet',
      content: 'Coinbase Wallet is a self-custody wallet that gives you complete control of your crypto for your Wallet.',
      btn_color: "btn-secondary"
    },
    {
      image: 'assets/images/nft/wallet/binance.png',
      title: 'Binance',
      content: 'Binance is considered a safe exchange that allows user account protection via the use of Two Authentication.',
      btn_color: "btn-soft-primary"
    },
  ];
  
  export { walletData };
  